<ng-template #modal let-addModal>
  <div class="modal-header">
    <!-- Heading will change for addwishlist and createWishlist -->
    <h2 class="modal-title">{{ (modalTitle ? modalTitle : modalHeader) | translate }}</h2>
    <button
      type="button"
      class="close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!--Dias Customization  buttonDisable() is added to disable the button if form has an error-->
  <form [formGroup]="wishListForm" (ngSubmit)="submitWishlistForm()" (keyup)="buttonDisable()">
    <div class="modal-body">
      <formly-form [form]="wishListForm" [fields]="fields" [model]="model"> </formly-form>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="buttonDisable() || formDisabled"
        data-testing-id="wishlist-dialog-submit"
      >
        {{ primaryButton | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="hide()">
        {{ 'account.wishlists.wishlist_form.cancel_button.text' | translate }}
      </button>
    </div>
  </form>
</ng-template>
